import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a18420a2&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a18420a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18420a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a18420a2')) {
      api.createRecord('a18420a2', component.options)
    } else {
      api.reload('a18420a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a18420a2&scoped=true&lang=pug", function () {
      api.rerender('a18420a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/thankYou/childrensday2024/index.vue"
export default component.exports